import React, { useEffect, useState } from "react";
import Table from "components/table/Table";
import { AddButton, SmallScreenModel } from "components";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { TableColumns } from "./components/TableColumns";
import HandlerCreateFAQ from "./HandleCreateFAQ";
import { connect } from "react-redux";
import { fetchFaq } from "../state/action";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const FAQTable: React.FC<Props> = ({ fetchFaq, onFetchFaq }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => {
    setModalOpen(false);
  };
  const openModal = () => setModalOpen(true);
  useEffect(() => {
    onFetchFaq();
  }, [onFetchFaq]);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_FAQ));
  return (
    <div className="">
      <Table
        headers={["FAQ"]}
        data={fetchFaq?.faq}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
            {isPermitted && (
              <AddButton
                onClick={openModal}
                label="Add FAQ"
                tooltip="Add new faq"
              />
            )}
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <div className="text-center">
          <HandlerCreateFAQ closeModal={closeModal} />
        </div>
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchFaq: state.faq?.fetchFaqState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchFaq: () => dispatch(fetchFaq()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FAQTable);
